module.exports = "h4.modal-title {\n    font-size: 17px;\n}\n"